import { Button, Dialog } from '../ui/primitives';
import { RESULT_EXPLANATION, RESULT_NOT_ACCOUNTING, RESULT_TERM, type ResultView } from '../../utils/inicioView';

/**
 * Rediseño · Bloque C — «Ver cómo se calcula» (la hoja «Cómo se calcula» de P-021 y P-030), con la
 * definición que el dueño decidió en B0-01.
 *
 * Es la capa educativa: aquí sí aparece el término «Resultado estimado», con su explicación y los
 * cuatro renglones en lenguaje cotidiano. Cada importe viene del servidor; esta hoja no resta nada.
 * La maqueta mostraba otra cuenta (ventas de hoy − costo, «sin renta ni luz») y «¢ de cada peso»:
 * el dueño conservó la métrica real, y esa frase se evita.
 */
export function ResultDialog({ view, onClose }: { view: ResultView; onClose: () => void }) {
  if (!view.breakdown) return null;
  return (
    <Dialog
      description={RESULT_EXPLANATION}
      footer={<Button onClick={onClose} variant="primary">Entendido</Button>}
      onClose={onClose}
      title={RESULT_TERM}
    >
      <p className="n3-inicio__support">{view.periodLabel}.</p>
      <dl className="n3-inicio__breakdown">
        {view.breakdown.map((row) => (
          <div className={row.isTotal ? 'n3-inicio__breakdown-row n3-inicio__breakdown-row--total' : 'n3-inicio__breakdown-row'} key={row.label}>
            <dt>{row.label}</dt>
            <dd>{row.amountLabel}</dd>
          </div>
        ))}
      </dl>
      {view.breakdownNote && <p className="n3-inicio__dialog-note">{view.breakdownNote}</p>}
      {view.approximateNote && <p className="n3-inicio__dialog-note">{view.approximateNote}</p>}
      {view.coverageText && <p className="n3-inicio__dialog-note">{view.coverageText}</p>}
      <p className="n3-inicio__dialog-note">{RESULT_NOT_ACCOUNTING} La cifra puede cambiar si hay costos que aún no están registrados.</p>
    </Dialog>
  );
}
